import React, { useState } from "react";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";

import { store } from "@components/VerticalLayout/store";
import {
    setLocalShop,
    setNumberActive,
    setNumberArchived,
    store as generalSettingStore,
    setIdsLocalShop,
    setLanguagesData,
    setArchivedLanguageFranchise,
    setLanguagesFranchise,
    setDataArchive,
    setArchivedLanguageOfFranchise,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setValidationAction,
    setKey,
} from "../store";

import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";

import { ConfirmationActiveLanguage } from "./ConfirmationActiveLanguage";
import { LanguageForm } from "./LanguageForm";
import { CustomSideFilter } from "./CustomSideFilter";
import { History } from "../History";
import { ConfirmationArchiveLanguage } from "../ConfirmationArchiveLanguage";
import { ConfirmationAssociateModifiedMessage } from "./ConfirmationAssociateModifiedMessage";

import { ConfirmationActivationDeactivationMessageModal } from "@components/Common/ConfirmationActivationDeactivationMessageModal";
import { store as StoreConfirmationActivationDeactivation } from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import {
    ActiveArchiveCount,
    defaultModalState,
    defaultTableState,
} from "../hooks";
import { ArrayOfCustomColumns } from "./ArrayOfCustomColumns";
import ModalLoading from "@components/Common/ModalLoading";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "../index.css";
import { useAuthHeader } from "../../../../api/headersKeycloak";

export function Languages({
    setIsArchivedLanguagesClicked,
    isArchivedLanguagesClicked,
    setLimit,
}: any) {
    const getAuthHeader = useAuthHeader();

    const { oneShop, userID, franchiseID, shopID } = useSnapshot(store);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { activationDeactivationMessageModalOpened } = useSnapshot(
        StoreConfirmationActivationDeactivation
    );
    const {
        isValidateArchiveOpened,
        isActionsClicked,
        isEdited,
        actions,
        validationAction,
        key,
        isLoading,
    } = useSnapshot(generalSettingStore);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );
    const [modalState, setModalState] = useState({ ...defaultModalState });
    const [dataTable, setDataTable] = React.useState<any>({});
    const [tableState, setTableState] = useState(
        defaultTableState(oneShop, shopID)
    );
    const modalLoadingData = {
        title: "Traitement en cours...",
        message: "Traitement en cours...",
    };
    const [dataState, setDataState] = useState<any>({});
    const urlArchive = `${process.env.REACT_APP_API_V2_URL}/settings/general/archived_language?userId=${userID}&shopId=${tableState.shopId}&franchiseId=${franchiseID}`;
    const urlActive = `${process.env.REACT_APP_API_V2_URL}/settings/general/language?userId=${userID}&shopId=${tableState.shopId}&franchiseId=${franchiseID}`;

    function setIsInInitializationModalOpened(value: boolean) {
        setModalState({ ...modalState, isInInitializationModalOpened: value });
    }
    function setIsAddNewLanguageButtonClicked(value: boolean) {
        setModalState({
            ...modalState,
            isAddNewLanguageButtonClicked: value,
            isInInitializationModalOpened: false,
        });
    }
    function setSelectedRows(data: any) {
        setTableState({ ...tableState, selectedRows: data });
    }
    function setDataIsUpdated(data: any) {
        setTableState({ ...tableState, dataIsUpdated: data });
    }
    function setLocalFilterActive(data: any) {
        setTableState({ ...tableState, filterActive: data });
    }
    React.useEffect(() => {
        const localShop = tableState.selectedRows.map((el) => el.shopId);
        const idsLocalShop = tableState.selectedRows.map((el) => el.Id);
        ActiveArchiveCount(dataTable, setNumberActive, setNumberArchived);
        setIdsLocalShop(idsLocalShop);
        setLocalShop(localShop);
        setLanguagesData(dataTable.data ?? []);
        const othersData: any = dataTable.othersData ?? {};
        setLanguagesFranchise(othersData.languagesOfFranchise ?? []);
        setArchivedLanguageFranchise(
            othersData.archivedLanguageFranchise ?? []
        );
        setDataArchive(othersData.dataArchive ?? []);
        setArchivedLanguageOfFranchise(othersData.dataOfFranchiseArchive ?? []);
    }, [tableState.selectedRows, dataTable]);

    React.useEffect(() => {
        if (tableState.filterActive)
            setModalState({ ...modalState, isAddLanguageClicked: false });
        // eslint-disable-next-line
    }, [tableState.filterActive]);

    React.useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(showPrompt as boolean);
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    React.useEffect(() => {
        if (oneShop) {
            setModalState({ ...modalState, isAddLanguageClicked: false });
            setKey(Math.floor(Math.random() * 10000));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18nextLng]);

    return (
        <React.Fragment>
            <div
                style={{
                    display: "grid",
                    minHeight: oneShop ? "650px" : "600px",
                    gridTemplateColumns: modalState.isAddLanguageClicked
                        ? "2fr 1fr "
                        : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
                key={key}
            >
                <DynamicTable
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    canMovedCheckboxLeftOnExpand
                    url={isArchivedLanguagesClicked ? urlArchive : urlActive}
                    setData={setDataTable}
                    canSelect
                    customSelect
                    setSelectedRows={setSelectedRows}
                    customJsxSideFilterButton={
                        <CustomSideFilter
                            setIsArchivedLanguagesClicked={
                                setIsArchivedLanguagesClicked
                            }
                            isArchivedLanguagesClicked={
                                isArchivedLanguagesClicked
                            }
                            setModalState={setModalState}
                            modalState={modalState}
                            tableState={tableState}
                            setTableState={setTableState}
                        />
                    }
                    canResize
                    showGlobalFilter
                    showFilter
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={tableState.filterActive}
                    actionColumn={() => <></>}
                    arrayOfCustomColumns={ArrayOfCustomColumns({
                        setDataState,
                        isArchivedLanguagesClicked,
                        modalState,
                        setModalState,
                        tableState,
                        setTableState,
                    })}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={tableState.dataIsUpdated}
                    elevationTable={1}
                    minHeight={oneShop ? "500px" : "450px"}
                    maxHeight={oneShop ? "500px" : "450px"}
                    name="language"
                />
                {modalState.isAddLanguageClicked && (
                    <LanguageForm
                        dataState={dataState}
                        setModalState={setModalState}
                        modalState={modalState}
                        tableState={tableState}
                        setTableState={setTableState}
                    />
                )}
            </div>
            {modalState.isInInitializationModalOpened && (
                <ConfirmationInitializationMessage
                    setIsEdited={setIsEdited}
                    isModalOpened={modalState.isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddNewLanguageButtonClicked}
                    isClicked={modalState.isAddNewLanguageButtonClicked}
                />
            )}
            {modalState.isHistoryModalOpened && (
                <History
                    setModalState={setModalState}
                    modalState={modalState}
                    setTableState={setTableState}
                    tableState={tableState}
                />
            )}
            <ConfirmationActiveLanguage
                isOneShop={true}
                setModalState={setModalState}
                modalState={modalState}
                setTableState={setTableState}
                tableState={tableState}
            />

            {isValidateArchiveOpened && (
                <ConfirmationArchiveLanguage
                    selectedRows={tableState.selectedRows}
                    setLimit={setLimit}
                />
            )}
            {isActionsClicked && (
                <ConfirmationUpdatingDataMessageModal
                    isModalOpened={isActionsClicked}
                    setIsModalOpened={setIsActionsClicked}
                    validationAction={validationAction}
                    actions={actions}
                    setIsEdited={setIsEdited}
                />
            )}
            {modalState.isAssociateModified && (
                <ConfirmationAssociateModifiedMessage
                    setModalState={setModalState}
                    modalState={modalState}
                    tableState={tableState}
                />
            )}
            {activationDeactivationMessageModalOpened && oneShop && (
                <ConfirmationActivationDeactivationMessageModal />
            )}
            {isLoading && (
                <ModalLoading isOpen={isLoading} data={modalLoadingData} />
            )}
        </React.Fragment>
    );
}
